const stores=['books','files','positions','bookmarks','audio'];
let database;
function openDatabase(){
  if(database)return database;
  const opening=new Promise((resolve,reject)=>{
    const request=indexedDB.open('webreader',1);
    request.onupgradeneeded=()=>{const db=request.result;for(const name of stores)db.createObjectStore(name,name==='books'?{keyPath:'id'}:undefined);};
    request.onerror=()=>reject(request.error);
    request.onsuccess=()=>{
      const db=request.result;
      const forget=()=>{if(database===opening)database=null;};
      db.onversionchange=()=>{forget();db.close();};
      db.onclose=forget;
      resolve(db);
    };
  });
  database=opening;
  opening.catch(()=>{if(database===opening)database=null;});
  return opening;
}
const result=request=>new Promise((resolve,reject)=>{request.onsuccess=()=>resolve(request.result);request.onerror=()=>reject(request.error);});
async function transaction(names,mode,work){
  const connection=openDatabase();
  let db=await connection,tx;
  try{tx=db.transaction(names,mode);}
  catch(error){
    if(error.name!=='InvalidStateError')throw error;
    if(database===connection)database=null;
    db=await openDatabase();
    tx=db.transaction(names,mode);
  }
  const done=new Promise((resolve,reject)=>{tx.oncomplete=resolve;tx.onabort=()=>reject(tx.error||Error('Storage transaction was aborted'));tx.onerror=()=>{};});
  try{const value=work(tx);return (await Promise.all([value,done]))[0];}
  catch(error){try{tx.abort();}catch{}await done.catch(()=>{});throw error;}
}
const read=(name,id)=>transaction([name],'readonly',tx=>result(id===undefined?tx.objectStore(name).getAll():tx.objectStore(name).get(id)));
const write=(name,id,value)=>transaction([name],'readwrite',tx=>{tx.objectStore(name).put(value,id);});
export const store={
  all(){return read('books');},
  get(id){return read('books',id);},
  add(book,file){return transaction(['books','files'],'readwrite',tx=>{tx.objectStore('books').put(book);if(file)tx.objectStore('files').put(file,book.id);});},
  file(id){return read('files',id);},
  position(id,data){return data===undefined?read('positions',id):write('positions',id,data);},
  async bookmarks(id,data){return data===undefined?(await read('bookmarks',id))||[]:write('bookmarks',id,data);},
  remove(id){return transaction(stores,'readwrite',tx=>{for(const name of stores)tx.objectStore(name).delete(id);});},
  audio(id,data){return data===undefined?read('audio',id):write('audio',id,data);},
  // All decoding and resource reads finish before opening this transaction.
  // Queue writes synchronously; a failure rolls the entire library restore back.
  restore(operations){return transaction(stores,'readwrite',tx=>{for(const operation of operations){
    if(operation.store==='books'){tx.objectStore('books').put(operation.value);if(operation.blob)tx.objectStore('files').put(operation.blob,operation.id);}
    else tx.objectStore(operation.store).put(operation.value,operation.id);
  }});},
  controlsPosition(){try{return JSON.parse(localStorage.getItem('webreader.controls-position')||'null');}catch{return null;}},
  readingPace(){try{return JSON.parse(localStorage.getItem('webreader.reading-pace')||'{}');}catch{return {};}},
  saveReadingPace(profiles){try{localStorage.setItem('webreader.reading-pace',JSON.stringify(profiles));}catch{}},
  settings(){try{return JSON.parse(localStorage.getItem('webreader.settings') || '{}');}catch{return {};}},
  saveSettings(s){localStorage.setItem('webreader.settings',JSON.stringify(s));},
};
export async function sha256(buffer){const hash=await crypto.subtle.digest('SHA-256',buffer);return [...new Uint8Array(hash)].map(b=>b.toString(16).padStart(2,'0')).join('');}
export function download(blob,name){const a=document.createElement('a');const url=URL.createObjectURL(blob);a.href=url;a.download=name;document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);}
export async function pickFiles(accept,multiple=false){return new Promise(resolve=>{const input=document.createElement('input');input.type='file';input.accept=accept;input.multiple=multiple;input.style.display='none';document.body.append(input);let settled=false;const finish=files=>{if(settled)return;settled=true;resolve([...files]);input.remove();};input.addEventListener('change',()=>finish(input.files));input.addEventListener('cancel',()=>finish([]));input.click();});}
